// extracted by mini-css-extract-plugin
export default {"topSection":"LoginForm_topSection__umKjd","form":"LoginForm_form__wYsba","loginBtn":"LoginForm_loginBtn__OPlFX","forgotPwdBtn":"LoginForm_forgotPwdBtn__VzU9m"};